/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Rounds_Seating_UnseatedInputs */



/**
* | output |
* | --- |
* | "{name} removed from the round" |
*
* @param {Rounds_Seating_UnseatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_unseated = /** @type {((inputs: Rounds_Seating_UnseatedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_UnseatedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} retiré(e) de la ronde`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} quitado/a de la ronda`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.name} removido/a da rodada`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} rimosso/a dal round`)
	return /** @type {LocalizedString} */ (`${i?.name} removed from the round`)
});